import asyncSeries from 'async/series';

import CounterStore from './counter_store';
import CryptoStore from './crypto_store';
import EventStore from './event_store';
import UserStore from './user_store';
import UserCurrencyStore from './user_currency_store';

export default {
  init,
};

function init(done) {
  asyncSeries(
    [
      UserStore.init,
      UserCurrencyStore.init,
      CryptoStore.init,
      EventStore.init,
      CounterStore.init,
    ],
    () => {
      done && done();
    }
  );
}
